// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'jquery'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueCookie from 'vue-cookie'


axios.defaults.baseURL = 'https://lk.when-hungry.com/mrkim/'
Vue.prototype.$http = axios

Vue.use(Loading)
Vue.use(VueCookie)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  data () {
    return {
      loader: null
    }
  },
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  created () {
    axios.interceptors.request.use(config => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      this.loader = Vue.$loading.show({
        loader: 'dots',
        opacity: 0.8,
        backgroundColor: 'transparent',
        color: '#54BB65',
        isFullPage: true
      })
      return config
    })
    axios.interceptors.response.use(response => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
      return response
    }, err => {
      if (this.loader !== null && this.loader !== undefined) this.loader.hide()
    })
  }
})
router.beforeEach((to, from, next) => {
  if (this.loader !== null && this.loader !== undefined && to.name) {
    this.loader = Vue.$loading.show({
      loader: 'dots',
      opacity: 0.8,
      backgroundColor: 'transparent',
      color: '#54BB65',
      isFullPage: true
    })
  }
  next()
})

router.afterEach((to, from) => {
  if (this.loader !== null && this.loader !== undefined) this.loader.hide()
})



// WEBPACK FOOTER //
// ./src/main.js